import type { HTMLAttributes, ReactNode } from "react";

export type BadgeKind = "live" | "win" | "bust" | "fair";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  kind: BadgeKind;
  children?: ReactNode;
}

export function Badge({ kind, className, children, ...rest }: BadgeProps) {
  const cls = ["vb-badge", `vb-badge-${kind}`, className].filter(Boolean).join(" ");
  return (
    <span className={cls} {...rest}>
      {children}
    </span>
  );
}
